/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { setScheduledTask } from "../../../store/api/tasks/reducer";
import { tasksSelector } from "../../../store/api/tasks/selector";
import { setErrorMsg } from "../../../store/helpers/helperReducers";
import { errorMsgSelector } from "../../../store/helpers/helperSelectors";
import { useStoreDispatch } from "../../../store/hooks";
import { NODE_CLI_PASSWARD_MAXLENGTH } from "../../../globals/globals";
import { RadixSelectControl } from "../../ui/radix-select";
import { Label } from "../../ui/label";
import { InputField } from "../../Shared/Radix/Inputs/InputField";
import { PasswordField } from "../../Shared/Radix/Inputs/PasswordField";

export const NodePasswordChange = () => {
    const dispatch = useStoreDispatch();
    const errorMsg = useSelector(errorMsgSelector);
    const scheduledtasks = useSelector(tasksSelector);

    useEffect(() => {
        !scheduledtasks?.username &&
            dispatch(setScheduledTask({ username: "field_recovery" }));
    }, [])
    const onPasswordChange = (name: string, value: string) => {
        dispatch(setScheduledTask({ [name]: value }));
        if (name === "confirmPassword" && scheduledtasks?.newPassword !== value) {
            dispatch(setErrorMsg({ ...errorMsg, [name]: "Passwords do not match" }));
        } else {
            dispatch(setErrorMsg({ ...errorMsg, [name]: "" }));
        }
    };
    useEffect(() => {
        dispatch(setScheduledTask({ username: scheduledtasks?.username ?? "field_recovery" }));
    }, [])

    const selectChangeHandler = (value: string) => {
        dispatch(setScheduledTask({ username: value }));
        dispatch(setErrorMsg({ ...errorMsg, username: "" }));
    };

    const onConfirmPasswordChange = (name: string, value: string) => {
        dispatch(setScheduledTask({ [name]: value }));
        if (scheduledtasks?.newPassword !== value) {
            dispatch(setErrorMsg({ ...errorMsg, [name]: "Passwords do not match" }));
        } else {
            dispatch(setErrorMsg({ ...errorMsg, [name]: "" }));
        }
    };

    const onBlurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (name === "confirmPassword") {
            if (scheduledtasks?.newPassword !== value) {
                dispatch(setErrorMsg({ ...errorMsg, [name]: "Passwords do not match" }));
            } else {
                dispatch(setErrorMsg({ ...errorMsg, [name]: "" }));
            }
        }
    };

    const onConfirmBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (scheduledtasks?.newPassword !== value) {
            dispatch(setErrorMsg({ ...errorMsg, [name]: "Passwords do not match" }));
        } else {
            dispatch(setErrorMsg({ ...errorMsg, [name]: "" }));
        }
    };

    return (
        <div className="flex flex-col gap-6">
            <p className="text-sm font-medium">Set the node user Password:</p>
            <div className="space-y-2">
                <Label>User Name</Label>
                <RadixSelectControl
                    options={[
                        { value: "field_recovery", label: "field_recovery" },
                        { value: "admin", label: "admin" },
                        { value: "roadmin", label: "roadmin" },
                    ]}
                    value={scheduledtasks.username || "field_recovery"}
                    placeholder="__placeholder__"
                    onValueChange={selectChangeHandler}
                />
            </div>
            <PasswordField
                name="password"
                label="Current Password"
                required
                value={scheduledtasks?.password || ""}
                placeholder="Enter current password"
                maxLength={NODE_CLI_PASSWARD_MAXLENGTH}
                onChange={onPasswordChange}
                onBlur={onBlurHandler}
            />
            <PasswordField
                name="newPassword"
                label="New Password"
                required
                value={scheduledtasks?.newPassword || ""}
                placeholder="Enter new password"
                maxLength={NODE_CLI_PASSWARD_MAXLENGTH}
                onChange={onPasswordChange}
                onBlur={onBlurHandler}
            />
            <div>
                <InputField
                    label="Confirm New Password"
                    name="confirmPassword"
                    value={scheduledtasks?.confirmPassword ?? ""}
                    type="password"
                    required
                    maxLength={NODE_CLI_PASSWARD_MAXLENGTH}
                    onChange={onConfirmPasswordChange}
                    onBlur={onConfirmBlur}
                    placeholder="Enter confirm new password"
                />
            </div>
        </div>
    );
};